/**
 * Нижний таб-бар — навигация узкого экрана.
 *
 * На широком экране его заменяют верхние табы шапки; переключение идёт по
 * размеру (`md:hidden`), поэтому бар и табы никогда не видны одновременно
 * и не дублируют друг друга.
 *
 * Пять равных пунктов на всю ширину — крупные мишени под палец. Активный
 * подсвечен плывущей подложкой и жирной подписью, чтобы выбор читался без цвета.
 * Главный пункт («Учиться») — посередине, иконка в приподнятом круге цвета
 * акцента: он виден, даже когда открыт другой экран.
 */

import { motion } from 'framer-motion';
import { NavLink } from 'react-router-dom';

import { NAV_ITEMS } from '../../app/navigation';
import { useTranslation } from 'react-i18next';

export function BottomNav() {
  const { t } = useTranslation();
  return (
    <nav
      className="glass pb-safe fixed inset-x-0 bottom-0 z-30 border-t border-line md:hidden"
      aria-label={t('nav.main')}
    >
      <div className="flex px-2 py-1.5">
        {NAV_ITEMS.map((item) =>
          item.primary === true ? (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                [
                  'relative flex flex-1 flex-col items-center gap-0.5 py-1',
                  'font-heading text-xs transition-colors',
                  isActive ? 'font-bold text-accent-dark' : 'font-semibold text-heading',
                ].join(' ')
              }
            >
              {({ isActive }) => (
                <>
                  <motion.span
                    className={[
                      '-mt-5 grid h-14 w-14 place-items-center rounded-full bg-accent text-on-accent ring-4 ring-page',
                      isActive ? 'shadow-[0_6px_22px_-4px_rgb(var(--c-accent)/0.75)]' : 'shadow-button',
                    ].join(' ')}
                    animate={{ scale: isActive ? 1.06 : 1 }}
                    whileTap={{ scale: 0.92 }}
                  >
                    <item.icon size={28} stroke={2.1} aria-hidden="true" />
                  </motion.span>
                  <span>{t(`nav.${item.labelKey}`)}</span>
                </>
              )}
            </NavLink>
          ) : (
          <NavLink
            key={item.to}
            to={item.to}
            className={({ isActive }) =>
              [
                'relative flex flex-1 flex-col items-center gap-0.5 rounded-2xl py-2',
                'font-heading text-xs transition-colors',
                isActive ? 'font-semibold text-accent-dark' : 'text-muted hover:text-heading',
              ].join(' ')
            }
          >
            {({ isActive }) => (
              <>
                {isActive && (
                  <motion.span
                    layoutId="bottom-tab"
                    className="absolute inset-0 rounded-2xl bg-accent/15"
                    transition={{ type: 'spring', stiffness: 420, damping: 34 }}
                  />
                )}
                <motion.span className="relative" animate={{ y: isActive ? -2 : 0, scale: isActive ? 1.12 : 1 }}>
                  <item.icon size={22} stroke={isActive ? 2.2 : 1.8} aria-hidden="true" />
                </motion.span>
                <span className="relative">{t(`nav.${item.labelKey}`)}</span>
              </>
            )}
          </NavLink>
          ),
        )}
      </div>
    </nav>
  );
}
